import { useState,useEffect } from 'react';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse, Label, Input } from 'reactstrap';
import { FaChevronUp, FaChevronDown, FaSlash } from 'react-icons/fa';
import uuid from 'react-uuid';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";

const ItemTypeListView = ({ Section, itemTypesList, toggleItemTypeListState, handleClearSelection, handleItemClick, handleItemTypeListTogole, isWizardCompleted, itemModel, gisLayerDetails, handleGISLayerDetails, gisLayerStockExclusionLandSlopeDetails, handleGISLayerStockExclusionLandSlopeDetails }) => {

    const [isOpen, setIsOpen] = useState(toggleItemTypeListState.isOpen);
    const [isIconUp, setIsIconUp] = useState(toggleItemTypeListState.isIconUp);
    const [isCropping, setIsCropping] = useState(false);
    const [isWaterways, setIsWaterways] = useState(false); const [isIrrigation, setIsIrrigation] = useState(false);
    const [isLandErosion, setIsLandErosion] = useState(false);
    const [isOther, setIsOther] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        handleItemTypeListTogole(!isOpen, !isIconUp);
    };
    useEffect(() => {
        if (Section == 'Cropping') {
            setIsCropping(true);
            setIsOther(false);
        }
        else if (Section == 'Land and Erosion') {
            setIsLandErosion(true);
            setIsOther(false);
        }
        else if (Section == 'WaterwaysMap' || Section == 'WaterwaysRisk') {
            setIsWaterways(true);
            setIsOther(false);
        }
        else if (Section == 'Irrigation') {
            setIsIrrigation(true);
            setIsOther(false);
        }
    }, []);
    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yesItem";
    const showToastMessage = (e, message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    return (
        <Card className="cardNonLeftRadius cardNonLeftRadius_margin" >
            <CardHeader className="item-header item_click card-header1">
                <Row className="itemTypeList-header-div">
                    {Section == 'Community & Cultural Significance' &&
                        <Col sm="11">
                            <Row> <h5 className="color-dark-teal">Mapping of Culturally or Community Significant Sites and Species&nbsp;&nbsp;
                                <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-8" onClick={(e) => e.stopPropagation()} /></h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-8"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    Click and drop the icon onto the Map and complete the pop up form. 
                                                    <br/>
                                                    For more information on how to add items to your map <a href="https://freshwaterfarmplan.co.nz/fwfp-support/drawing-map-features/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                            </Row>
                        </Col>       
                    }
                    {
                        Section == 'InfrastructureMap'  &&
                        <Col><Row>
                                <h5 className="color-dark-teal">Identify Infrastructure and Areas&nbsp;&nbsp;&nbsp;
                                    <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-9" onClick={(e) => e.stopPropagation()} /></h5>
                                <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                    id="my-tooltip-9"
                                    place="top"
                                    variant="info"
                                    render={({ content, activeAnchor }) => (
                                        <>
                                            <Row>
                                                <Col>
                                                    <>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            <b>CCA treated post piles</b> – Identify storage areas of timber vineyard posts treated with Copper, Chromium and Arsenic (CCA). Include piles of new and broken vineyard posts. Information and resources for the waste focus area can be found on the NZW Members website.
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            <b>Bores/surface water abstraction points</b> - These may be situated off your property but should be marked on the map. These should include fish screens if used.
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            <b>Private drinking water supply points</b> - e.g. water bore or spring on the property for drinking water. If your drinking water is supplied by your regional council e.g. reticulated, this is not required to be marked on the map.
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            <b>Irrigation water storage</b> – Water storage e.g. dam or pond used for irrigation
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            <b>Vineyard accessways</b> – Formed roads, tracks, races and underpasses.
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            <b>Rubbish dumps</b> – Existing and old rubbish dumps including any offal pits
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            <b>Sheep dip sites</b> - Existing and old sheep dip sites
                                                        </p>
                                                    </>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                />
                            </Row>
                        </Col>
                    }
                    {
                         Section == 'InfrastructureRisk' &&
                        <Col><Row>
                                <h5 className="color-dark-teal">Infrastructure&nbsp;&nbsp;&nbsp;
                                    {/*<img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-9" onClick={(e) => e.stopPropagation()} />*/}
                                </h5>
                        </Row>
                        </Col>
                    }
                    {
                        Section == 'WaterwaysMap'  &&
                        <Col ><Row>
                                <h5 className="color-dark-teal">Identify Waterways&nbsp;&nbsp;&nbsp; 
                                    <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-10" onClick={(e) => e.stopPropagation()} /></h5>
                                <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                    id="my-tooltip-10"
                                    place="top"
                                    variant="info"
                                    render={({ content, activeAnchor }) => (
                                        <>
                                            <Row>
                                                <Col>
                                                    {itemModel.isMapOnly &&
                                                        <>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                                <b>Pond</b> – A small body of water formed naturally or by artificial means
                                                            </p>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                            <b>Wetland</b> - A wetland includes permanently or intermittently wet areas, shallow water, and land water margins that support a natural ecosystem of plants and animals that are adapted to wet conditions.
                                                            </p>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                            <b>Stopbank or levee</b> - Stopbank or levees are used to protect land from flooding from a nearby river.
                                                            </p>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                            <b>Culvert</b> – A structure that carries a body of water under a road, track, railway or other obstruction. These are typically made of Polyethylene pipe, corrugated steel, aluminium or concrete.
                                                            </p>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                            <b>Drain</b> – Identify open and closed drains including subsurface drains such as French drains and mole drains. Subsurface drains may not require fencing and can be noted when adding the icon onto the map
                                                            </p>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                            <b>Waterway crossing</b> – freshwater crossings, including formed crossings, such as bridges and culverts if not already identified, fords and other unformed crossings
                                                            </p>
                                                            <p style={{ fontWeight: "lighter" }}>
                                                            <b>Water sampling point</b> - Identify any sites you may have taken samples for monitoring water quality or water ecosystems
                                                            </p>
                                                        </>
                                                    }
                                                    
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                />
                            </Row>
                        </Col>
                    }
                    {
                        Section == 'WaterwaysRisk' &&
                        <Col ><Row>
                            <h5 className="color-dark-teal">Waterways&nbsp;&nbsp;&nbsp;
                                    {/*<img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-10" onClick={(e) => e.stopPropagation()} />*/}
                                </h5>
                            {/*<ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}*/}
                            {/*    id="my-tooltip-10"*/}
                            {/*    place="top"*/}
                            {/*    variant="info"*/}
                            {/*    render={({ content, activeAnchor }) => (*/}
                            {/*        <>*/}
                            {/*            <Row>*/}
                            {/*                <Col>*/}
                            {/*                    <p style={{ fontWeight: "lighter" }}>*/}
                            {/*                        For more information on adding Waterways <a href="https://freshwaterfarmplan.co.nz/support-category/waterways-and-crossings/" target="_blank" rel="noreferrer">Click Here</a>*/}
                            {/*                    </p>*/}
                            {/*                </Col>*/}
                            {/*            </Row>*/}
                            {/*        </>*/}
                            {/*    )}*/}
                            {/*/>*/}
                        </Row>
                        </Col>
                    }
                    {
                        Section == 'Land and Erosion' &&
                        <Col ><Row> <h5 className="text-capitalize fw-bold color-dark-teal"> Land and Erosion Areas&nbsp;&nbsp;&nbsp;
                                <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-11" onClick={(e) => e.stopPropagation()} /></h5>
                                <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                    id="my-tooltip-11"
                                    place="top"
                                    variant="info"
                                    render={({ content, activeAnchor }) => (
                                        <>
                                            <Row>
                                                <Col>
                                                    <p style={{ fontWeight: "lighter" }}>
                                                        For more information on Land and Erosion <a href="https://freshwaterfarmplan.co.nz/support-category/land-units/" target="_blank" rel="noreferrer">Click Here</a>
                                                    </p>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                />
                            </Row>
                        </Col>
                    }
                   
                    {
                        Section == 'Nutrients' &&
                        <Col><Row> <h5 className="text-capitalize fw-bold color-dark-teal"> Nutrient Detail&nbsp;&nbsp;&nbsp;
                            </h5>
                            </Row>
                        </Col>
                    }
                    {
                        Section != 'Community & Cultural Significance' && Section != 'InfrastructureMap' && Section != 'WaterwaysMap' && Section != 'InfrastructureRisk' && Section != 'WaterwaysRisk' && Section != 'Land and Erosion' 
                        && Section != 'Nutrients'  &&
                        <Col sm="11"><Row> <span className="text-capitalize fw-bold color-dark-teal">{Section}</span></Row>
                        </Col>
                    }
                </Row>
            </CardHeader>
                <CardBody>
                    <Row>
                    <Col>

                        {Section == 'Community & Cultural Significance' &&

                            <label className="fw-bold info-text">Please indicate on the map any SITES or SPECIES which are significant to tangata whenua and/or threatened, either on the property, or down stream from the property.
                            <br />
                                        These can include Taonga or threatened Species, or sites of high cultural value of community significance such as Wahi Tapu, fish spawning areas, drinking water protection zones, or recreational sites.
                            </label>
                        }
                        {Section == 'InfrastructureMap' &&
                            <label className="fw-bold info-text">Click an icon and place it on the map to mark your vineyard infrastructure.</label>
                        }
                        {Section == 'InfrastructureRisk' &&
                            <label className="fw-bold info-text"> Review the mapped items, consider any that might contribute to environmental risk, and raise actions to mitigate.</label>
                        }
                        {(Section == 'WaterwaysMap' || Section == 'WaterwaysRisk') &&

                            <>
                                <Row>

                                <>
                                    <Col sm="8">
                                        <Row>
                                            <Col>
                                                <label className="external-map-title">Definitions of waterways:</label>
                                            </Col>
                                        </Row>
                                        <Row >
                                            <Col  >
                                                <ul className="external-map-sub">
                                                    <li>Ephemeral – an area where water only flows during and shortly after rainfall, e.g. ditch that is dry most of the time, swale.</li>
                                                    <li>Intermittent – a waterway that ceases to flow for some periods of the year or at least twice every 5 years.</li>
                                                    <li>Perennial – a waterway that is full or continues to flow throughout the year for all or most years.</li>
                                                    <li>Groundwater - Groundwater is the water present beneath Earth's surface.</li>
                                                </ul>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <label className="external-map-title">Waterway Map Key</label>
                                            </Col>
                                        </Row>
                                        <Row >
                                            <Col><FaSlash color='#0000FF'></FaSlash> <span className="external-map-sub">  = 100% Fenced (or not required)</span></Col>
                                        </Row>
                                        <Row >
                                            <Col><FaSlash color='#FFA500'></FaSlash> <span className="external-map-sub">  = Not Fully Fenced</span> </Col>
                                        </Row>

                                    </Col>
                                </>
                                    
                                </Row>
                            </>

                        }

                        {Section == 'WaterwaysMap' && <label className="fw-bold info-text">Click an icon and place or draw on the map to mark the waterways on your vineyard.</label>}

                        {Section == 'Land and Erosion' &&
                            <label className="fw-bold info-text"> Click the icons then draw on the map to mark any relevant areas.</label>
                        }
                        {Section == 'Nutrients' &&
                            <label className="fw-bold info-text"> Consider how nutrients are applied to the vineyard.</label>
                        }
                        </Col>
                </Row>
                <hr />
                {
                 (itemModel.isMapOnly || itemModel.isMapRisk) &&
                    <Row>
                        <Col>
                            <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                {/*    {Section == 'Nutrients' &&*/}
                                {/*    <Row>*/}
                                {/*        <Col>*/}
                                {/*            <label className="outlineLabel para-light-sm ">Click the icon then click on the farm map to add</label>*/}
                                {/*            <Button style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} className="btnClearSelection float-end" color="warning" size="sm" onClick={handleClearSelection}>*/}
                                {/*                Clear Selection*/}
                                {/*            </Button>*/}
                                {/*        </Col>*/}
                                {/*    </Row>*/}
                                {/*}*/}
                                    {Section != 'Nutrients' &&
                                        <Row style={{ display: "none" }}>
                                        <Col>
                                            <label className="outlineLabel para-light-sm ">Click Icon then Map to add</label>
                                            <Button style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} className="btnClearSelection float-end" color="warning" size="sm" onClick={handleClearSelection}>
                                                Clear Selection
                                            </Button>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col>
                                        <Row>
                                            {itemTypesList.map(type =>
                                                <Col key={uuid()} sm="4" className="style-item-display">
                                                    <Row style={{ marginTop: "-0.65vh" }}>
                                                        <Col sm="12">
                                                            {isWaterways &&
                                                                <>
                                                                    <img
                                                                        className="featureIconNew"
                                                                        src={"/images/ItemIcons/" + type.icon}
                                                                        onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                    />
                                                                    {type.name == 'Lake' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                                    {type.name == 'Lake' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} </label>}
                                                                    {type.name == 'Pond' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                                    {type.name == 'Pond' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} </label>}
                                                                    {type.name != 'Pond' && type.name != 'Lake' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>}
                                                                </>
                                                            }
                                                            {isLandErosion &&
                                                                <>
                                                                    <img
                                                                        className="featureIconNew"
                                                                        src={"/images/ItemIcons/" + type.icon}
                                                                        onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                    />
                                                                    {type.name == 'Areas that hold water' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                                    {type.name == 'Areas that hold water' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} </label>}
                                                                    {type.name != 'Areas that hold water' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>}
                                                                </>
                                                            }
                                                            {isOther && Section != 'Nutrients' &&
                                                                <>
                                                                    <img
                                                                        className="featureIconNew"
                                                                        src={"/images/ItemIcons/" + type.icon}
                                                                        onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                    /> <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            )}
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                }
                </CardBody>
        </Card>
    )
}
export default ItemTypeListView